import Axios from 'axios';
import moment from 'moment';
import { all, call, cancel, fork, put, select, take, takeLatest } from 'redux-saga/effects';
import { extractLinksToJson, getApiServiceUrlByComponentAndMethod, getPrinterUrl, getPromotionalUrl, getReaderRetriveInterval, getReaderUrl, gettranId, parseHtml, serviceConsumer, serviceConsumerWithOutHeaders } from '../../helpers/helpersIndex';
import { EKioskTypes, IAppointment, IappointmentRequest, ICheckInRequest, IkioskConfigdata, IkioskMenuIds, IKioskOtherServiceMenu, IkioskPromotionalData, ImobileAuthRequest, IOtherServicesTokenRequest } from '../../models/kioskModel';
import * as types from './actionTypes';
import * as actions from './actions';
let KIOSK = "Kiosk";



function* getThemsAndMenus(action) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_getThemsAndMenusData_Start => `, action);
    let kisokId: number = 0;
    let kioskIdentifier = 'kid';
    const t = action?.payload?.t
    let errorMessage: string | undefined;
    let locationId: number | undefined;
    let logInMenus: IKioskOtherServiceMenu[] | any;
    let welcomeMenus: IKioskOtherServiceMenu[] | any;
    let otherServicesMenu: IKioskOtherServiceMenu[] | any;
    let kioskConfigData: IkioskConfigdata | undefined;
    let isNewPatientRegistration: IKioskOtherServiceMenu | any;
    let isWalkin: IKioskOtherServiceMenu | any
    let identifier: string = (yield select())["kioskReducer"]["kioskIdentifier"] || "";
    let currenttime: string = (yield select())["kioskReducer"]["currentDateAndTime"] || new Date();
    let previousselectedpage: string = (yield select())["kioskReducer"]["selectedPage"];
    let kioskStartTime: string | undefined;
    let kioskEndTime: string | undefined;
    let kioskType: string | undefined;
    let clientlogo: string | undefined;
    let promotionalData: IkioskPromotionalData[] | undefined;
    let idleTime: number | undefined;
    let selectedPage;
    let staticLoginMenus = [
        { branchId: 1, key: "insertYourEmeratesID", branchTypeCode: IkioskMenuIds.INSERTEMIRATESID },
        { branchId: 2, key: "scanYourappointment", branchTypeCode: IkioskMenuIds.SCANQR },
        { branchId: 3, key: "inputYourMobileNumber", branchTypeCode: IkioskMenuIds.INPUTMOBILE },
        { branchId: 4, key: "newPatientRegistration", branchTypeCode: IkioskMenuIds.NEWPATIENT },
    ];

    const staticMenus = [
        { branchId: 1, key: "appointments", branchTypeCode: IkioskMenuIds.APPOINMENTS },
        { branchId: 2, key: "labmenu", branchTypeCode: IkioskMenuIds.LAB },
        { branchId: 3, key: "radilogymenu", branchTypeCode: IkioskMenuIds.RADIOLOGY },
        { branchId: 4, key: "pharmacymenu", branchTypeCode: IkioskMenuIds.PHARMACY },
        { branchId: 5, key: "otherServices", branchTypeCode: IkioskMenuIds.OTHERSERVICES }
    ]
    try {
        // let getKioskDataMethod = getApiServiceUrlByComponentAndMethod(KIOSK, 'getKioskInfoByIdentifier');
        let getKioskDataMethod = getApiServiceUrlByComponentAndMethod(KIOSK, 'getHpKioskInfoByIdentifier');
        getKioskDataMethod.url = getKioskDataMethod.url.replace('{kioskIdentifier}', action?.payload?.kioskIdentifier || identifier);
        console.log(`${tranId}_getThemsAndMenusData_Api_Request => `, getKioskDataMethod, action?.payload, t);
        const response = yield call(serviceConsumer, tranId, getKioskDataMethod, null, null);
        console.log(`${tranId}_getThemsAndMenusData_Api_Response => `, response);
        if (response) {
            let menusFiltered = response.branches?.filter((x) => x?.branchTypeCode === "NCL");
            otherServicesMenu = menusFiltered;
            isNewPatientRegistration = (response.branches?.find((x) => x?.isNewRegistration === 1) || undefined);
            isWalkin = (response.branches?.find((x) => x?.isWalkin === 1) || undefined);
            kioskIdentifier = action?.payload?.kioskIdentifier || identifier;
            kisokId = response?.kioskId;
            kioskStartTime = response?.startTime;
            kioskEndTime = response?.endTime;
            locationId = response?.locationId;
            logInMenus = (response.branches?.find((x) => x?.isNewRegistration === 1)) ? staticLoginMenus : staticLoginMenus?.filter((x) => x?.branchId !== 4);
            promotionalData = response?.promotionalFiles;
            idleTime = response?.idleTime;
            welcomeMenus = staticMenus?.filter((x) => response?.branches?.map(branch => branch?.branchTypeCode)?.includes(x?.branchTypeCode));
            kioskType = response?.kioskType;
            if (action.payload?.action) {
                selectedPage = IkioskMenuIds.LOGINPAGE;
                clientlogo = response?.kioskLogoPath || undefined;
                yield put(actions.getCurrentTimeRequest());
                let configdata = yield call(getKioskConfigData, { kisokId, locationId });
                if (!configdata?.errorMessage) kioskConfigData = configdata?.kioskConfigData;
                else errorMessage = configdata?.errorMessage;
            }
            else {
                let starttime = response?.startTime || undefined;
                let endTime = response?.endTime || undefined;
                const startMoment = moment(starttime, "HH:mm");
                const endMoment = moment(endTime, "HH:mm");
                const currentMoment = moment(currenttime);
                const isStartTimeExceeded = currentMoment.isSameOrAfter(startMoment, 'minute');
                const isEndTimeExceeded = currentMoment.isSameOrAfter(endMoment, 'minute');
                const startTimeExceed = currentMoment.isBefore(startMoment, 'minute');
                if (starttime && endTime) {
                    if ((isStartTimeExceeded && isEndTimeExceeded) || (startTimeExceed)) {
                        selectedPage = IkioskMenuIds.LOGINPAGE;
                    }
                    else selectedPage = previousselectedpage;
                }
                else selectedPage = previousselectedpage;
            }
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (error) {
        console.log(`${tranId}_getThemsAndMenusData_catch => `, error);
        errorMessage = 'EM0';
    }
    console.log(`${tranId}_getThemsAndMenusData_End => `, { kisokId, welcomeMenus, otherServicesMenu, action: action?.payload?.action, errorMessage, kioskStartTime, kioskEndTime, kioskConfigData, kioskIdentifier, logInMenus, isNewPatientRegistration, isWalkin, selectedPage, kioskType, clientlogo, promotionalData, idleTime });
    yield put(actions.KioskIdAndGetMenusDataResponse(kisokId, welcomeMenus, otherServicesMenu, errorMessage, kioskStartTime, kioskEndTime, kioskIdentifier, locationId, logInMenus, kioskConfigData, isNewPatientRegistration, isWalkin, action.payload.action, selectedPage, kioskType, clientlogo, promotionalData, idleTime));
}

function* mobileVerification(action) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}__Start => `, action);
    let locationId: number = (yield select())["kioskReducer"]["locationId"] || 0;
    let selectedPage: string = (yield select())["kioskReducer"]["selectedPage"] || IkioskMenuIds.LOGINPAGE;
    let kioskType: any = (yield select())["kioskReducer"]["kioskType"] || null;
    let errorMessage: string | undefined;
    let verifyStatus: boolean | undefined;
    let patientId: number | undefined;
    let requestObj =
        {
            "mobileNumber": action.payload?.mobileNumber?.replace("+", ""),
            "dob": action.payload?.dob,
            "locationId": locationId
        } as ImobileAuthRequest;
    console.log("mobileVerification_RequestObj==>", requestObj);
    try {
        let verificationComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, "authenticationByMobileInKiosk");
        console.log(`${tranId}_mobileVerification_Api_Request => `, verificationComponentAndMethod, action?.payload);
        const response = yield call(serviceConsumer, tranId, verificationComponentAndMethod, requestObj, null);
        console.log(`${tranId}mobileVerification__Api_Response => `, response);
        if (response.status) {
            verifyStatus = response.status;
            patientId = response?.patient?.patientId;
            selectedPage = [EKioskTypes.GENERAL, null]?.includes(kioskType) ? IkioskMenuIds.APPOINMENTS : IkioskMenuIds.WELCOMEPAGE;
            yield call(getAppointmentsOnKiosk, response?.patient?.patientId);
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (error) {
        console.log(`${tranId}_mobileVerification_catch => `, error);
        errorMessage = 'EM0';
    }
    console.log(`${tranId}_mobileVerification_End => `, verifyStatus, patientId, selectedPage, errorMessage);
    yield put(actions.mobileVerification_Response(verifyStatus, patientId, selectedPage, errorMessage));
}

function* getEmiratesIdRequest(action) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_getEmiratesIdRequest_Start => `, action);
    let errorMessage: string | undefined;
    let emiratesData: any | undefined;
    let emiratesId: any | undefined;
    let url = getReaderUrl();
    let i = 0;
    let loopInterval = getReaderRetriveInterval() ? getReaderRetriveInterval() : 3;
    while (i < loopInterval) {
        errorMessage = undefined;
        try {
            console.log(`${tranId}_getEmiratesIdRequest_Api_Request => `, i);
            // let response = { status: false, emratesId: 5686767590 }
            const response = yield call(serviceConsumerWithOutHeaders, url);
            console.log(`${tranId}_getEmiratesIdRequest_Api_Response => `, response);
            if (response?.status) {
                i = loopInterval;
                emiratesData = response;
                emiratesId = response.emratesId;
            }
            else
                i++;
        } catch (error) {
            console.error(`${tranId}_getEmiratesIdRequest_error => `, error);
            console.log(`${tranId}_getEmiratesIdRequest_catch => `, error);
            i++;
            errorMessage = 'EM0';
        }
    }
    console.log(`${tranId}_getEmiratesIdRequest_End => `, emiratesData, emiratesId, errorMessage);
    yield put(actions.emiratesId_Response(emiratesData, emiratesId, errorMessage));
    if (!errorMessage && emiratesId)
        yield call(verifiedEmiratesId, tranId);
    else {
        yield put(actions.loadingAction(false))
    }
}

function* verifiedEmiratesId(tranId) {
    console.log(`${tranId}_verifiedEmiratesId_Start => `, tranId);
    let locationId: any = (yield select())["kioskReducer"]["locationId"] || 0;
    let emiratesId: any = (yield select())["kioskReducer"]["emiratesId"] || 0;
    let selectedPage: string = (yield select())["kioskReducer"]["selectedPage"] || IkioskMenuIds.LOGINPAGE;
    let kioskType: any = (yield select())["kioskReducer"]["kioskType"] || null;
    let verifyStatus: boolean | undefined;
    let patientId: number | undefined;
    let errorMessage: string | undefined;
    try {
        let regComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, 'verifyEmiratesId');
        regComponentAndMethod.url = regComponentAndMethod.url.replace("{emiratesid}", emiratesId).replace('{locationId}', locationId);
        console.log(`${tranId}_verifiedEmiratesId_Api_Request => `, regComponentAndMethod, locationId);
        const response = yield call(serviceConsumer, tranId, regComponentAndMethod, null, null);
        console.log(`${tranId}_verifiedEmiratesId_Api_Response => `, response);
        if (response.status) {
            verifyStatus = response.status;
            patientId = response?.patient?.patientId;
            selectedPage = [EKioskTypes.GENERAL, null]?.includes(kioskType) ? IkioskMenuIds.APPOINMENTS : IkioskMenuIds.WELCOMEPAGE;
            yield call(getAppointmentsOnKiosk, response?.patient?.patientId);
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (error) {
        errorMessage = 'EM0';
        console.log(`${tranId}_verifiedEmiratesId_catch => `, error);
    }
    console.log(`${tranId}_verifiedEmiratesId_end=> `, verifyStatus, patientId, selectedPage, errorMessage);
    yield put(actions.emiratesVerification_Response(verifyStatus, patientId, selectedPage, errorMessage));
}

function* getQrcodeVerification(action) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_getQrcodeVerification_Start => `, action);
    let locationId: number = (yield select())["kioskReducer"]["locationId"] || 0;
    let selectedPage: string = (yield select())["kioskReducer"]["selectedPage"] || IkioskMenuIds.LOGINPAGE;
    let kioskType: any = (yield select())["kioskReducer"]["kioskType"] || null;
    let errorMessage: string | undefined;
    let verifyStatus: boolean | undefined;
    let patientId: number | undefined;
    let requestObj =
    {
        qrCodeString: action?.payload,
        locationId: locationId
    }
    console.log(`${tranId}_getQrcodeVerification_RequestObj==> `, requestObj);
    try {
        let verificationComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, "authenicationByQRInKiosk");
        console.log(`${tranId}_getQrcodeVerification_Api_Request => `, verificationComponentAndMethod, requestObj);
        const response = yield call(serviceConsumer, tranId, verificationComponentAndMethod, requestObj, null);
        console.log(`${tranId}getQrcodeVerification__Api_Response => `, response);
        if (response.status) {
            verifyStatus = response.status;
            patientId = response?.patient?.patientId;
            selectedPage = [EKioskTypes.GENERAL, null]?.includes(kioskType) ? IkioskMenuIds.APPOINMENTS : IkioskMenuIds.WELCOMEPAGE;
            yield call(getAppointmentsOnKiosk, response?.patient?.patientId);
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (error) {
        console.log(`${tranId}_getQrcodeVerification_catch => `, error);
        errorMessage = 'EM0';
    }
    console.log(`${tranId}_getQrcodeVerification_End => `, verifyStatus, patientId, selectedPage, errorMessage);
    yield put(actions.QrcodeVarificationResponse(verifyStatus, patientId, selectedPage, errorMessage));
}
function* getAppointmentsOnKiosk(patient) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_getAppointmentsOnKiosk_Start => `, tranId);
    let appointmentsData: IAppointment[] | undefined;
    let errorMessage: string | undefined;
    let patientId: number = patient || 0;
    let kioskId: number = (yield select())["kioskReducer"]["kioskId"] || 0;
    let requestObj = {
        kioskId: kioskId,
        patientId: patientId
    } as IappointmentRequest;
    try {
        let appointmentComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, "getHpAppointmentsByPatientId")
        console.log(`${tranId}_getAppointmentsOnKiosk_Api_Request => `, appointmentComponentAndMethod);
        const response = yield call(serviceConsumer, tranId, appointmentComponentAndMethod, requestObj, null);
        console.log(`${tranId}_getAppointmentsOnKiosk_Api_Response => `, response);
        if (response) {
            appointmentsData = response.appointments;
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (error) {
        console.error(`${tranId}_getAppointmentsOnKiosk_error => `, error);
        console.log(`${tranId}_getAppointmentsOnKiosk_catch => `, error);
        errorMessage = 'EM0';
    }
    console.log(`${tranId}_getAppointmentsOnKiosk_Api_end==>`, appointmentsData, errorMessage);
    yield put(actions.appointmentsResponse(appointmentsData, errorMessage));
    return { appointmentsData, errorMessage };
}

function* getPrintTokenData(action) {
    let tranId = gettranId(KIOSK);
    let tokenData: any = JSON.parse(action.payload);
    let errorMessage: string | undefined;
    let response: any;
    let printerUrl: any = getPrinterUrl();
    console.log(`${tranId}_getPrintTokenData_start==>`, { tranId, tokenData, action, printerUrl })
    try {
        response = yield Axios.post(printerUrl, tokenData)
        console.log(`${tranId}_getPrintTokenData_response==>`, { response, tokenData })
    }
    catch (err) {
        errorMessage = "EM0";
        console.log(`${tranId}_getPrintTokenData_catch==>`, { err })
    }
    yield put(actions.printTockendataResponse(response))
    return { response }
}

function* generateCheckIntoken(action) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_generateCheckIntoken_Start => `, action);
    let tokenType: number = action?.payload?.tokentype;
    let encounterId: number | any = action?.payload?.Id || 0;
    let appointmentsData: IAppointment[] = (yield select())["kioskReducer"]["appointmentsData"] || [];
    let locationId = (yield select())["kioskReducer"]["locationId"] || 0;
    let kioskId: number = (yield select())["kioskReducer"]["kioskId"] || 0;
    let errorMessage: string | undefined;
    let tokenData: string | undefined;
    let requestObj =
        {
            accompanyVisitors: 0,
            checkInMode: "KIOSKCHECKIN",
            eventId: encounterId,
            kioskId: kioskId,
            locationId: locationId,
            userId: 0
        } as ICheckInRequest;
    try {
        let checkinComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, "checkIn");
        console.log(`${tranId}_generateCheckIntoken_Api_Request => `, { checkinComponentAndMethod, requestObj });
        const response = yield call(serviceConsumer, tranId, checkinComponentAndMethod, requestObj, null);
        console.log(`${tranId}_generateCheckIntoken_Api_Response => `, response);
        if (response.status) {
            tokenData = response;
            let index = appointmentsData?.findIndex((x: IAppointment) => x?.encounterId === encounterId);
            let getObject = appointmentsData[index];
            appointmentsData.splice(index, 1, { ...getObject, serviceStatus: "" });
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (error) {
        console.error(`${tranId}_generateCheckIntoken_error => `, error);
        console.log(`${tranId}_generateCheckIntoken_catch => `, error);
        errorMessage = 'EM0';
    }
    console.log(`${tranId}_generateCheckIntoken_End => `, tokenData, tokenType, appointmentsData, errorMessage);
    yield put(actions.generateCheckInToken_Response(tokenData, tokenType, appointmentsData, errorMessage));
}

function* generateManualToken(action) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_generateManualToken_Start => `, action);
    let tokenType: number = action.payload.tokentype;
    let locationId: number | any = (yield select())["kioskReducer"]["locationId"] || 0;
    let patientId: number = (yield select())["kioskReducer"]["patientId"] || 0;
    let kioskId: number = (yield select())["kioskReducer"]["kioskId"] || 0;
    let tokenData: any | undefined;
    let errorMessage: string | undefined;
    let requestObj =
        {
            branchId: action.payload.Id,
            kioskId: kioskId,
            locationId: locationId,
            patientId: patientId,
            sendSms: true,
            mobileNo: action.payload?.mobileNo?.replace("+", "") || null
        } as IOtherServicesTokenRequest;
    try {
        let checkinComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, "generateManualTokenForOtherService");
        console.log(`${tranId}_generateManualToken_Api_Request => `, { checkinComponentAndMethod, requestObj });
        const response = yield call(serviceConsumer, tranId, checkinComponentAndMethod, requestObj, null);
        console.log(`${tranId}_generateManualToken_Api_Response => `, response);
        if (response.status) {
            tokenData = response;
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (error) {
        console.error(`${tranId}_generateManualToken_error => `, error);
        console.log(`${tranId}_generateManualToken_catch => `, error);
        errorMessage = 'EM0';
    }
    console.log(`${tranId}_generateManualToken_End => `, tokenData, tokenType, errorMessage);
    yield put(actions.generateOtherServicesToken_Response(tokenData, tokenType, errorMessage));
}

function* rePrintToken(action) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_rePrintToken_Start => `, action);
    let encounterId: number | any = action?.payload?.Id;
    let tokenType: number = action?.payload?.tokentype;
    let locationId: number | any = (yield select())["kioskReducer"]["locationId"] || 0;
    let userId: number | any = (yield select())["kioskReducer"]["kioskId"] || 0;
    let tokenData: any | undefined;
    let errorMessage: string | undefined;
    try {
        let regComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, 'rePrintToken');
        regComponentAndMethod.url = regComponentAndMethod.url.replace("{userId}", userId).replace("{encounterId}", encounterId).replace("{locationId}", locationId);
        console.log(`${tranId}_rePrintToken_Api_Request => `, regComponentAndMethod, locationId);
        const response = yield call(serviceConsumer, tranId, regComponentAndMethod, null, null);
        console.log(`${tranId}_rePrintToken_Api_Response => `, response);
        if (response.status) {
            tokenData = response;
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (error) {
        errorMessage = 'EM0';
        console.log(`${tranId}_rePrintToken_catch => `, error);
    }
    console.log(`${tranId}_rePrintToken_end=> `, tokenData, tokenType);
    yield put(actions.rePrintToken_Response(tokenData, tokenType, errorMessage));
}


function* getKioskConfigData(requestdata) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_getKioskConfigData_start==>`, { tranId, requestdata })
    let kioskConfigData: IkioskConfigdata[] | undefined;
    let userId = requestdata?.kisokId || 0;
    let locationId = requestdata?.locationId || 0;
    let errorMessage: string | undefined;
    try {
        let regComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, 'getKioskConfigMessages');
        regComponentAndMethod.url = regComponentAndMethod.url.replace("{userId}", userId).replace("{locationId}", locationId);
        console.log(`${tranId}_getKioskConfigData_Api_Request => `, regComponentAndMethod, locationId);
        const response = yield call(serviceConsumer, tranId, regComponentAndMethod, null, null);
        console.log(`${tranId}_getKioskConfigData_Api_Response => `, response);
        if (response) {
            kioskConfigData = response;
        }
        else {
            errorMessage = response.messages ? response.messages : "EM0";
        }
    }
    catch (err) {
        errorMessage = "EM1";
        console.log(`${tranId}_getKioskConfigData_catch => `, err);
    }
    console.log(`${tranId}_getKioskConfigData_end=> `, kioskConfigData, errorMessage);
    return { kioskConfigData, errorMessage }
}

function* getCurrentTimeAction() {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_getCurrentTimeAction => `,);
    let dateTime;
    try {
        let checkinComponentAndMethod = getApiServiceUrlByComponentAndMethod(KIOSK, 'getCurrentDate');
        console.log(`${tranId}_getCurrentTimeAction_Api_Request => `, checkinComponentAndMethod);
        const response = yield call(serviceConsumer, tranId, checkinComponentAndMethod, null, null);
        console.log(`${tranId}_getCurrentTimeAction_Api_Response => `, response);
        if (response) {
            dateTime = response.dateTime;
            yield put(actions.getCurrentTimeResponse(dateTime));
        }
    }
    catch (error) {
        console.error(`${tranId}_getCurrentTimeAction_error => `, error);
        console.log(`${tranId}_getCurrentTimeAction_catch => `, error);
    }
    console.log(`${tranId}_getCurrentTimeAction_End => `, dateTime);
}

function* getPromotionalSlides(action) {
    let tranId = gettranId(KIOSK);
    console.log(`${tranId}_getPromotionalSlides => `, action);
    let url = getPromotionalUrl()
    let promotionalUrlsData
    if (url) {
        try {
            let checkinComponentAndMethod = {
                "name": "promotionalSlides",
                "type": "GET",
                "url": url
            };
            console.log(`${tranId}_getPromotionalSlides_Api_Request => `, checkinComponentAndMethod);
            const response = yield call(serviceConsumer, tranId, checkinComponentAndMethod, null, null);
            console.log(`${tranId}_getPromotionalSlides_Api_Response => `, response);
            if (response) {
                const html = response
                const doc = parseHtml(html); // Parse the HTML into a DOM
                promotionalUrlsData = extractLinksToJson(doc); // Extract links and convert to JSON
            }
        }
        catch (error) {
            console.error(`${tranId}_getPromotionalSlides_error => `, error);
            console.log(`${tranId}_getPromotionalSlides_catch => `, error);
        }
        console.log(`${tranId}_getPromotionalSlides_end => `, promotionalUrlsData);
        yield put(actions.setPromotionalDataResponse(promotionalUrlsData))
    }
}
function* KIOSKWatcher() {
    while (true) {
        const getKioskMenus = yield takeLatest(types.KIOSK_ID_AND_GET_MENUS_DATA_REQUEST, getThemsAndMenus);
        const varification = yield takeLatest(types.MOBILE_VERIFICATION_REQUEST, mobileVerification);
        const emiratesData = yield takeLatest(types.EMIRATESID_REQUEST, getEmiratesIdRequest);
        const QrcodeVerification = yield takeLatest(types.QRCODE_VERIFICATION_REQUEST, getQrcodeVerification);
        const appointment = yield takeLatest(types.APPOINTMENTS_REQUEST, getAppointmentsOnKiosk);
        const printToken = yield takeLatest(types.REPRINT_TOCKEN_REQUEST, rePrintToken);
        const ReprintToken = yield takeLatest(types.PRINT_TOCKEN_REQUEST, getPrintTokenData);
        const getTokensByChecking = yield takeLatest(types.GENERATE_CHECKIN_TOKEN_REQUEST, generateCheckIntoken);
        const getTokensByOtherServices = yield takeLatest(types.GENERATE_OTHERSERVICES_TOKEN_REQUEST, generateManualToken);
        const currentTimeRequest = yield takeLatest(types.GET_CURRENT_TIME_REQUEST, getCurrentTimeAction);
        // const getPromotionalSlidesRequest = yield takeLatest(types.GET_PROMOTIONAL_FILES_REQUEST, getPromotionalSlides);
        yield take(types.SETRESET_ACTION);
        yield cancel([getKioskMenus, varification, emiratesData, appointment, printToken, ReprintToken, getTokensByChecking, getTokensByOtherServices, currentTimeRequest, QrcodeVerification]);
    }
}
function* kioskSaga2() {
    yield all([fork(KIOSKWatcher)]);
}
export default kioskSaga2;